import { Component, OnInit } from '@angular/core';
import { MasterBlogComponent } from '../../blog/master-blog/master-blog.component';

@Component({
  selector: 'app-search-blog',
  templateUrl: './search-blog.component.html'
})
export class SearchBlogComponent extends MasterBlogComponent {

}



// WEBPACK FOOTER //
// ./src/app/components/blog/search-blog/search-blog.component.ts